import { fetchAvsWorkspaceId } from '@jira/router-resources__itam/src/avsWorkspaceResource.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { HamViewsResponse } from './hamViewsTypes.tsx';

export const HAM_VIEWS_RESOURCE_KEY = 'ITAM_HAM_DASHBOARD_VIEWS';

export const hamViewsResource: RouteResource<HamViewsResponse> = createResource<HamViewsResponse>({
	type: HAM_VIEWS_RESOURCE_KEY,
	getKey: ({ match }) => {
		const practice = match.params.practice ?? '';
		return `${HAM_VIEWS_RESOURCE_KEY}_${practice}`;
	},
	getData: async (_routerContext, { tenantContext }) => {
		const cloudId = tenantContext?.cloudId;
		if (!cloudId) {
			throw new Error('Unable to fetch HAM views: missing tenantContext.cloudId');
		}
		const avsWorkspaceId = await fetchAvsWorkspaceId(cloudId);
		if (avsWorkspaceId == null) {
			throw new Error('AVS workspace ID not available');
		}
		return performGetRequest<HamViewsResponse>(
			`/gateway/api/jsm/reporting/assets-vertical/workspace/${avsWorkspaceId}/vertical/ham/v1/views`,
		);
	},
	maxAge: 1000 * 60 * 5, // 5 minutes
});
